<template>
    <div>
        <FormManager
            :initialFormValues="extent_raw_fields"
            :prettyEndPoint="prettyEndPoint"
            :events="events"
            @save="save"
            @cancel="cancel"
        />
    </div>
</template>

<script>
    export default {
        name: "EditExtent",
        props: ['extent_raw_fields'],
        mounted() {
        },
        data() {
            return {
                events: {
                    save: {
                        label: "Save" ,
                        event: "save"
                    },
                    cancel: {
                        label: "Cancel",
                        event: "cancel"
                    }
                },
            }
        },
        methods: {
            save: function (values, is_modified) {
                axios.patch('/extents/' + this.extent_raw_fields.id, {
                    fields: values
                }).then(response => {
                    console.log('saved')
                    this.$emit('save');
                }).catch(error => {
                    console.log('oops save')
                    console.log(error)
                })
            },
            cancel: function () {
                this.$emit('cancel')
            }
        },
        computed: {
            prettyEndPoint: function () {
                return '/api/utilities/pretty_extent_definition_map/' + this.extent_raw_fields.id
            }
        },
    }
</script>

<style scoped>

</style>